angular
    .module('dashboard')
    .component('orderItems',
        {
            templateUrl: 'components/orders/orderitem/orderitems.b7c43f76.html',
            restrict: 'E',
            bindings: {
                model : '='
            }
        });